import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import loadMyPurchaseHistory from "@NA/Handlers/PurchaseHistory/LoadMyPurchaseHistory";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import ADIProductGridCard from "./PurchaseHistory/ADIProductGridCard";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { defaultPaginationValues } from "@NA/Store/Reducer/ADIMyPurchaseHistoryConfigReducer";
import Link from "@insite/mobius/Link";
import translate from "@insite/client-framework/Translate";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { StyledButton } from "@insite/mobius/Clickable";
const enum fields {
    showImage = "showImage",
    showBrand = "showBrand",
    showPartNumbers = "showPartNumbers",
    showAvailability = "showAvailability",
    showPrice = "showPrice",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImage]: boolean;
        [fields.showBrand]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showAvailability]: boolean;
        [fields.showPrice]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const location = getLocation(state).pathname;
    const isOrderPage = !!location.toLowerCase().match(/orders?/);
    return {
        isLoading: state.ADIGlobalData.myPurchaseHistoryStore.isLoading,
        purchaseHistoryData: state.ADIGlobalData.myPurchaseHistoryStore.myPurchaseHistory,
        view: state.ADIGlobalData.myPurchaseHistoryStore.view,
        purchaseHistoryConfigState: state.ADIGlobalData.myPurchaseHistoryConfig,
        isOrderPage,
    };
};

const mapDispatchToProps = {
    loadMyPurchaseHistory,
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface RecentlyPurchasedProductCondensedStyles {
    cardGridContainer?: GridContainerProps;
    cardGridItem?: GridItemProps;
    gridCardDivider?: InjectableCss;
    wrapper?: InjectableCss;
    noProductsText?: TypographyPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    heading?: InjectableCss;
}

export const recentlyPurchasedProductCondensedStyles: RecentlyPurchasedProductCondensedStyles = {
    cardGridContainer: {
        gap: 10,
        css: css`  
       
        `,
    },
    cardGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        flex-basis: 50% !important;
                        max-width: 50% !important;
                    `,
                    css`
                        flex-basis: 33.33% !important;
                        max-width: 33.33% !important;
                    `,
                    css`
                        flex-basis: 20% !important;
                        max-width: 20% !important;
                    `,
                    css`
                        flex-basis: 20% !important;
                        max-width: 20% !important;
                    `,
                ])}
        `,
    },
    gridCardDivider: {
        css: css`
            padding: 10px;
            height: 100%;
            width: 100%;
            overflow: hidden;
            border-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                       margin-left:2.5px;
                       margin-right:2.5px;
                       padding:0px !important;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noProductsText: {
        variant: "h4",
        css: css`
            display: block;
            margin: auto;
        `,
    },
    heading: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 60px 0 0 0;
            margin-bottom: 4px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding: 37px 0 0 0;
                    `,
                    css`
                    padding: 37px 0 0 0;
                    `,
                    css`
                    padding: 37px 0 0 0;
                    `,
                    null,
                    null,
                ])}
                > ${TypographyStyle} {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            font-size: 19px;
                            line-height: normal;
                            margin-bottom: 5px;
                        `,
                    css`
                            font-size: 19px;
                            line-height: normal;
                            margin-bottom: 5px;
                        `,
                    null,
                    null,
                    null,
                ])}
                }
                > ${StyledButton} {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            font-size: 14px;
                            font-weight: bold;
                            `,
                    css`
                            font-size: 14px;
                            font-weight: bold;
                            `,
                    null,
                    null,
                    null,
                ])}
                }
        `,
    },
};

const styles = recentlyPurchasedProductCondensedStyles;

const RecentlyPurchasedProductCondensed: FC<Props> = ({
    isLoading,
    purchaseHistoryData,
    fields,
    id,
    view,
    loadMyPurchaseHistory,
    purchaseHistoryConfigState,
    isOrderPage,
}) => {

    const isShopMyBranchPage = window.location.pathname.includes('shopmybranch'); // This path check is being used by P21

    React.useEffect(() => {
        if (!isLoading && purchaseHistoryConfigState) {
       
            loadMyPurchaseHistory(
                {
                    toDate: "",
                    fromDate: "",
                    searchText: "",
                    isShopMyBranch: isShopMyBranchPage ? true : false,
                    pageName: isShopMyBranchPage ?  "purchasehistory-ShopMyBranch": "purchasehistory",
                    sortType: purchaseHistoryConfigState.pagination.sortType,
                    // pageName: "purchasehistory", // Code from Spire Prod
                     pagination: { // code from spire prod.
                        ...defaultPaginationValues,
                        pageSize: 5,
                    },
                     // pagination: purchaseHistoryConfigState.pagination, // To show only 5 products commenting the code.
                }
            );
        }
    }, [purchaseHistoryConfigState]); // purchaseHistoryConfigState is being used by P21

    if (isLoading && !isOrderPage) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} data-test-selector="RecentlyPurchasedProductListSpinner" />
            </StyledWrapper>
        );
    }

    if (!purchaseHistoryData?.products) {
        return null;
    }

    const products = purchaseHistoryData?.products;

    if (products?.length === 0) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.centeringWrapper} data-test-selector="productListNoneFound">

                </StyledWrapper>
            </StyledWrapper>
        );
    }

    const overriddenProps = { ...fields };
    if (getIsWebCrawler()) {
        overriddenProps.showAvailability = false;
    }
    const isMobileTab = window.innerWidth <= 1080;

    return (
       <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.heading}>
                <Typography variant="h3">Recently Purchased Products</Typography>
                <Link href="/MyAccount/RecentlyPurchasedProducts">{translate("View All")}</Link>
            </StyledWrapper>
            <LoadingOverlay loading={isLoading}>
                <GridContainer {...styles.cardGridContainer}>
                    {products.slice(0, isMobileTab ? 3 : products.length).map(product => (
                        <GridItem {...styles.cardGridItem} key={product.id}>
                            <StyledWrapper {...styles.gridCardDivider}>
                                <ADIProductGridCard
                                    key={product.id}
                                    product={product}
                                    view={view ? view : "Grid"}
                                    showBrand={fields.showBrand}
                                    showPartNumbers={fields.showPartNumbers}
                                    showPrice={fields.showPrice}
                                    showAvailability={fields.showAvailability}
                                    sourceName="Recently Purchased"
                                />
                            </StyledWrapper>
                        </GridItem>
                    ))}
                </GridContainer>
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RecentlyPurchasedProductCondensed),
    definition: {
        group: "My Account",
        displayName: "Recently Purchased Products",
        fieldDefinitions: [
            {
                name: fields.showImage,
                displayName: "Show Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.showBrand,
                displayName: "Show Brand",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Show Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showAvailability,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 6,
            },
            {
                name: fields.showPrice,
                displayName: "Show Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 8,
            },
        ],
    },
};

export default widgetModule;
